<template>
  <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.15702 4.62112L0 6L4.82608 10.0496L11.7682 1.77628L10.3893 0.61926L4.60422 7.51366L1.15702 4.62112Z" fill="white"/>
  </svg>
</template>